import { ContentGrid } from '../../../components/organisms/contentGrid/ContentGrid';
import tastify from '@frontastic/catwalk/src/js/helper/tastify';
import React from 'react';

function ImageGridTastic({ data, context }) {
  if (!data) return null;

  const locale = context?.locale === 'en_AU@AUD' ? 'AU' : 'NZ';
  if (!data[`show${locale}`]) return null;

  return <ContentGrid data={data} type="media" isLinkCovered />;
}

export default tastify({ translate: true, connect: { context: true } })(ImageGridTastic);
